export const AUTH_USER_SUCCESS = "AUTH_USER_SUCCESS";
export const AUTH_USER_ERROR = "AUTH_USER_ERROR";
export const AUTH_USER_REQUEST = "AUTH_USER_REQUEST";

export const UPLOAD_REQUEST = "UPLOAD_REQUEST";
export const UPLOAD_SUCCESS = "UPLOAD_SUCCESS";

export const LOGOUT_USER = "LOGOUT_USER";
export const ADD_NOK = "ADD_NOK";
